import { FC, useEffect, useMemo, useState } from "react";

import Button from "components/Button";

import { GatewaysApi } from "services/http";
import { getModalCallbacks } from "store/slices/modalCallbacksRegistry";

import styles from "../styles.module.scss";

type PropTypes = {
  onClose?: () => void;
  id?: number;
  name?: string;
  callbackKey?: string;
};

const ModalRemoveGatewayContent: FC<PropTypes> = ({ onClose, id, name, callbackKey }) => {
  const callbacks = useMemo(() => (callbackKey ? getModalCallbacks(callbackKey) : undefined), [callbackKey]);

  const [sensorsCount, setSensorsCount] = useState(0);

  useEffect(() => {
    if (id === undefined || id === null) return;
    let cancelled = false;
    GatewaysApi.getSensorCount(id)
      .then(({ data }) => {
        if (!cancelled) setSensorsCount(data?.count ?? 0);
      })
      .catch(() => {
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const handleDelete = () => {
    callbacks?.onClick?.();
    onClose?.();
  };

  const handleCancel = () => {
    onClose?.();
  };

  return (
    <div>
      <p className={styles.description}>
        Are you sure you want to delete {name ? `'${name}'` : "this"} gateway?
      </p>

      <div className={styles.warning}>
        <p className={styles.warningText}>
          Warning: {sensorsCount} {sensorsCount === 1 ? "device" : "devices"} will be disconnected from the network and
          stop reporting.
        </p>
        <span className={styles.warningBar} />
      </div>

      <p className={styles.note}>
        Gateway configuration guide, network registration, and connection history will be permanently deleted. Sensor
        data and alert history will not be affected. This action cannot be undone.
      </p>

      <div className={styles.buttons}>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ModalRemoveGatewayContent;
